import { AccountGroup } from '../model/account-group/account-group.model';
import { AccountGroupUpdate } from '../model/account-group/account-group-update.model';
import { ProductUpdate } from '../model/account-group/product-update.model';
import { Product } from '../model/account-group/product.model';

/**
 * Transformer - transforms data for update backend format.
 */
export class AccountTransformer {

    /**
     * Transforms Account Group for update - removes all unnecessary fields.
     *
     * @param {AccountGroup[]} accountGroups input account groups
     * @return {AccountGroupUpdate[]} output account groups
     */
    public transform(accountGroups: AccountGroup[]): AccountGroupUpdate[] {
        return accountGroups.map(group => new AccountGroupUpdate(this.transformProducts(group.products)));
    }

    /**
     * Transform products.
     *
     * @param {Product[]} products input products
     * @return {ProductUpdate[]} output products
     */
    private transformProducts(products: Product[]) {
        return products ? products.map(product => new ProductUpdate(product.number, product.enabled)) : [];
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/account-transformer.service.ts